import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = lazy(() => import('modules/ai/pages/Settings/RootPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.ai.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'one'),
      },
      children: [
        {
          path: navigation.settings.ai.credits.path,
          element: <RootPage />,
          handle: {
            meta: () => getSettingPageMeta(navigation, 'one'),
          },
        },
      ],
    },
  ]
}

export default settingsRoutes
